<template>
    <v-dialog max-width="500px" v-model="show">
        <v-card>
            <v-card-title class="headline">Ask For Help</v-card-title>
            <v-card-text>
                <p class="body-1">
                    <b>
                        Feeling a little over worked? Does it seem like no one
                        else is busy?
                    </b>
                </p>
                <p>
                    Use this tool to see if you can ask another member of the
                    company to help you with your task.
                </p>
                <v-select v-model="task" label="Which task would you like to pass on?" outlined :items="eligibleTasks" :item-text="taskString" item-value="id"></v-select>
                <p>
                    <b>Note:</b> not everyone will be able to help, and it might take others more effort to do the same task. We suggest that you ask <b>first</b>!
                </p>
                <v-select v-model="player" label="Who would you like to take it on?" outlined :items="eligiblePlayers" item-text="name" item-value="id"></v-select>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="show = false">Close</v-btn>
                <v-btn text color="primary" @click="sendRequest()" :disabled="!task || !player">Request</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { kebabToTitle } from '../util';

export default {
    props: {
        value: Boolean
    },
    data: () => ({
        task: null,
        player: null
    }),
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                return this.$emit("input", value);
            }
        },
        ...mapState({
            tasks: state => state.tasks,
            players: state => state.players,
            playerId: state => state.playerId
        }),
        eligibleTasks() {
            if (!this.tasks) { return []; }
            return Object.values(this.tasks).filter(task => !task.complete);
        },
        eligiblePlayers() {
            return this.players.filter(p => p.id !== this.playerId);
        }
    },
    methods: {
        taskString(t) {
            return `${t.title} (${kebabToTitle(t.action)})`;
        },
        sendRequest() {
            this.$socket.client.emit("ask_for_help", {
                action: "request",
                task: this.task,
                player: this.player
            });
            this.task = null;
            this.player = null;
            this.show = false;
        }
    }
}
</script>
